var React = require('react');

function Flame (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.4,35.4c-1.4-3.8-3.4-7.4-5.6-10.8L25.1,1.9C25,1.8,25,1.7,24.9,1.7s-0.3-0.1-0.4-0.1s-0.2,0-0.3,0.1\n\tc-0.1,0-0.2,0.1-0.3,0.2L7.6,27.1c-0.6,0.7-9.4,12.3-5.7,27.3c3.7,15.3,16.2,22.3,16.3,22.3c0.1,0.1,0.2,0.1,0.3,0.1l0,0\n\tc0.3,0,0.5-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.5-0.6c0.4-0.8,0-1.7-1-3.2c-2.2-3-5.8-9.6-5.7-15.6c0.2-6.3,5.3-12.2,7.4-14.7\n\tc1.6-1.6,5.5-6.6,6.9-10.2c0,0.1,0,0.2,0,0.3c0.2,0.9,0.3,1.6,0.5,2.5c0.6,3.4,1.1,6.9,2.2,10.3c0.6,1.8,1.5,3.5,2.4,5.3\n\tc1.1,2.2,2.3,4.4,2.7,6.7c0.5,2.6-0.2,8.9-0.5,9.6c-0.1,0.2-0.1,0.3-0.1,0.5s0.1,0.3,0.1,0.4c0.1,0.2,0.3,0.3,0.5,0.4\n\ts0.4,0.1,0.6,0.1c1.1-0.1,4.3-1.3,9.4-11.9C47.9,50.9,47.6,43.6,44.4,35.4z"}));
}

Flame.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 48 78.5"};

module.exports = Flame;

Flame.default = Flame;
